import { render, staticRenderFns } from "./Padron2.vue?vue&type=template&id=4ade3b92&scoped=true&"
import script from "./Padron2.vue?vue&type=script&lang=js&"
export * from "./Padron2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ade3b92",
  null
  
)

export default component.exports